<script setup lang="ts" generic="T, MM">
import { SitePickerDataQuery, SitePickerDataQueryVariables } from '@/generated/graphql'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import SelectField, { SelectOption } from '@/components/input/SelectField.vue'
import { computed, watch } from 'vue'
import { itemSortByName } from '@/app'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  withArchived?: boolean
  label?: string
}>()
const model = defineModel<string | undefined>()

const { t } = useI18n()

const label = computed(() => props.label || t('entity.site.singular'))

const fetchQuery = useQuery<SitePickerDataQuery, SitePickerDataQueryVariables>(gql`
  query SitePickerData {
    site {
      sites {
        id
        name
        archived
      }
    }
  }
`)
const options = computed<SelectOption<string>[]>(() =>
  itemSortByName(
    fetchQuery.result.value?.site.sites.filter((s) => !s.archived || props.withArchived),
    (c) => c.name,
  ).map((c) => ({
    title: c.name,
    value: c.id,
  })),
)
watch(options, (v) => {
  if (v.length == 1) {
    model.value = v[0].value
  }
  if (v.length == 0) {
    model.value = undefined
  }
})
</script>

<template>
  <select-field v-model="model" :items="options" :label="label">
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </select-field>
</template>

<style scoped lang="scss"></style>
